// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root___AXbr","left":"InfoRow_left__gmgYR"};